import { useQuery } from '@tanstack/react-query';

import { DDComponent } from '@telialt/utils/src/datadog/setup';
import { useLogError } from '@telialt/utils/src/datadog/useLogError';

import { SEARCH_QUERY_KEYS } from '../constants';
import { SearchFilters, SearchQueryParams } from '../model';
import { loadProductsCustomQuery } from './DataLoading/LoadProductsCustomQuery';

type Params = {
    queryKey?: string;
    filters?: SearchFilters;
    sort?: SearchQueryParams['sort'];
    limit?: number;
};

export const useLoadProductsCustomQuery = ({ queryKey, filters, sort, limit }: Params) => {
    const {
        data,
        isFetching: isResultsLoading,
        error,
    } = useQuery({
        queryKey: [SEARCH_QUERY_KEYS.SEARCH_RESULTS_PRODUCTS_CUSTOM_QUERY, queryKey, filters, sort, limit],
        queryFn: async ({ signal }) => {
            if (!queryKey) {
                throw new Error('Missing products query key');
            }

            return loadProductsCustomQuery({ queryKey, filters, sort, limit, signal });
        },
        enabled: !!queryKey,
    });
    useLogError(error, DDComponent.Search);

    return { isLoading: isResultsLoading, error, data };
};
